import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { Button, Text, View } from "../components/base";
import { sessionActions } from "../redux/reducers/sessionSlice";
import { useAppDispatch, useAppSelector } from "../redux";
import { useNavigation } from "../hooks/useNavigation";
import { AuthLayout } from "../components/auth/AuthLayout";
import { SignInForm } from "../components/auth/SignInForm";

export const SignInPage = () => {
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector((state) => state.session.isLoading);
  const error = useAppSelector((state) => state.session.error);
  const user = useAppSelector((state) => state.session.user);
  const invite = useAppSelector((state) => state.session.invite);
  const [searchParams] = useSearchParams();

  const onSubmit = async (formData: { email: string; password: string }) => {
    dispatch(sessionActions.signIn({ ...formData, inviteId: invite?.id }));
  };

  useEffect(() => {
    if (user) {
      const returnUrl = searchParams.get("returnUrl");
      if (returnUrl) {
        window.location.href = returnUrl;
      } else {
        navigation.navigate("/");
      }
    }
  }, [user]);

  return (
    <AuthLayout
      title="Welcome Back"
      subtitle="Sign in to continue to VoiceRun"
      footer={
        <View className="flex flex-col items-center gap-2">
          <View className="flex items-center space-x-1">
            <Text variant="muted">Don't have an account?</Text>
            <span
              className="font-medium text-brand dark:text-brand-light hover:underline cursor-pointer"
              onClick={() => navigation.navigate("/signup")}
            >
              Sign up
            </span>
          </View>
          <span
            className="text-sm text-gray-500 dark:text-gray-400 hover:underline cursor-pointer"
            onClick={() => navigation.navigate("/forgot-password")}
          >
            Forgot your password?
          </span>
        </View>
      }
    >
      <SignInForm
        onSubmit={onSubmit}
        isLoading={isLoading}
        error={error ? String(error) : undefined}
      />
    </AuthLayout>
  );
};
